// extracted by mini-css-extract-plugin
export default {"container":"EmailSendModal_container__VZjNZ"};